const useCurrencySymbol = (currency: string) => {
  let symbol: string;

  if (currency === 'AZN') {
    symbol = '₼';
  } else if (currency === 'USD') {
    symbol = '$';
  } else if (currency === 'EUR') {
    symbol = '€';
  } else if (currency === 'RUB') {
    symbol = '₽';
  } else {
    symbol = currency;
  }

  return symbol;
};

export default useCurrencySymbol;
